import { Form, Input, Button, Modal } from 'antd';
import { CheckCircleFilled, MinusCircleOutlined, LockOutlined } from '@ant-design/icons';
import DatePicker from '_helpers/DatePicker';
import dayjs from '_helpers/datetime';
import {useEffect} from 'react';
import {useRecoilState} from 'recoil';


import { useProfileAction } from '_actions';
import { ROLES } from '_helpers/roles';
import { alertBachAtom } from '_state';
import { useState } from 'react';

import locale from 'antd/es/date-picker/locale/vi_VN';
import { ConfigProvider } from 'antd';


export{ ProfileForm}

const dateFormat = 'DD/MM/YYYY';

// Live password strength meter + requirement checklist for the new-password field.
function pwdScore(p) {
    if (!p) return 0;
    let s = 0;
    if (p.length >= 6) s++;
    if (p.length >= 10) s++;
    if (/[A-Z]/.test(p) && /[a-z]/.test(p)) s++;
    if (/\d/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return Math.min(s, 4);
}
const STRENGTH = [
    { label: '', tone: '' },
    { label: 'Yếu', tone: 'bad' },
    { label: 'Trung bình', tone: 'warn' },
    { label: 'Khá', tone: 'info' },
    { label: 'Mạnh', tone: 'ok' },
];
function PasswordStrength({ value }) {
    if (!value) return null;
    const score = pwdScore(value);
    const { label, tone } = STRENGTH[score];
    const reqs = [
        { ok: value.length >= 8, label: 'Ít nhất 8 ký tự' },
        { ok: /[A-Z]/.test(value) && /[a-z]/.test(value), label: 'Chữ hoa và chữ thường' },
        { ok: /\d/.test(value), label: 'Có chữ số' },
        { ok: /[^A-Za-z0-9]/.test(value), label: 'Có ký tự đặc biệt' },
    ];
    return (
        <div className="pwd-strength">
            <div className="pwd-meter">
                {[1, 2, 3, 4].map(i => (
                    <span key={i} className={'pwd-seg' + (i <= score ? ` pwd-seg-on tone-${tone}` : '')} />
                ))}
            </div>
            {label && <div className={`pwd-label tone-${tone}`}>{label}</div>}
            <div className="pwd-reqs">
                {reqs.map((r, i) => (
                    <span key={i} className={'pwd-req' + (r.ok ? ' pwd-req-ok' : '')}>
                        {r.ok ? <CheckCircleFilled /> : <MinusCircleOutlined />}{r.label}
                    </span>
                ))}
            </div>
        </div>
    );
}



function ProfileForm(props) {
    const profileAction = useProfileAction(); 
    const [form] = Form.useForm();
    const [alert, setAlert] = useRecoilState(alertBachAtom);
    const [pwOpen, setPwOpen] = useState(false);
    const [pwLoading, setPwLoading] = useState(false);
    const [newPwd, setNewPwd] = useState('');
    const [pwForm] = Form.useForm();
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    const userData = JSON.parse(localStorage.getItem("userData"));
    let data = props.data;
    let isTable = props.isTable;

    if (data == null) {
        profileAction.getMyProfile().then( newData =>{
                data = newData;
            }
        )
    }

    const openPwModal = () => { pwForm.resetFields(); setNewPwd(''); setPwOpen(true); };
    const closePwModal = () => { setPwOpen(false); setNewPwd(''); pwForm.resetFields(); };

    const submitPassword = async () => {
        try {
            setPwLoading(true);
            const v = await pwForm.validateFields();
            await profileAction.handleSubmit(
                { old_password: v.old_password, new_password: v.new_password },
                data.student_id, isTable
            );
            setPwLoading(false);
            closePwModal();
        } catch (e) {
            setPwLoading(false);
            if (e && e.errorFields) return; // form validation errors already shown inline
            setAlert({ message: "Lỗi", description: e });
        }
    }

    useEffect (() => {
        if (data !== undefined){
            // data = profile;
            form.resetFields();
        }
        
    },[data])

    // useEffect (() => {
    //     form.resetFields();
    // },[data])

    function formatDate(timestamp) {
        let formatedDateOfBirth = dayjs(timestamp).format("DD/MM/YYYY");
        return formatedDateOfBirth
    }

    const cancelEdit = () => {
        setAlert({message: "Thành công", description: "Đã cập nhật lại các thông tin !"});
        form.resetFields();
    }     

    const handleSubmit = async () => {
        try {
			setSubmitButtonLoading(true)
            let values = await form.validateFields();
            // Confirm field + the section toggle are client-only — never sent to the API.
            delete values.new_password_confirm;
            delete values.password_switch;
            const changedFields = Object.fromEntries(
                Object.entries(values).filter(([, v]) => v)
            );
          	if(changedFields.date_of_birth) {
                let timestamp = String(dayjs(changedFields.date_of_birth, 'DD/MM/YYYY').valueOf());
                changedFields.date_of_birth = timestamp;
          	}
          	await profileAction.handleSubmit(changedFields, data.student_id, isTable);
			setSubmitButtonLoading(false);
        } catch (e) {
            setAlert({message: "Lỗi", description: e});
        }
    }

    const avatarInitial = (data?.name || '?').trim()[0].toUpperCase();

    return (
        (data)?

        <div className="profile-card">
            <div className="profile-card-head">
                <div className="profile-avatar">{avatarInitial}</div>
                <div>
                    <div className="profile-card-name">{data.name}</div>
                    <div className="profile-card-role">
                        {data.role === ROLES.TEACHER ? "Giáo viên" : data.role === ROLES.MANAGER ? "Quản lý hệ thống" : data.role === ROLES.HEADMASTER ? "Hiệu trưởng" : "Học sinh"}
                    </div>
                </div>
            </div>

            <Form
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                layout="vertical"
                className="profile-form"
                form = {form}
            >
                <div className="profile-form-grid">
                    <Form.Item label="Họ và tên" name = "name">
                        <Input defaultValue = {data.name} />
                    </Form.Item>

                    <Form.Item label={data.role === ROLES.MANAGER ? 'Manager ID' : data.role === ROLES.TEACHER || data.role === ROLES.HEADMASTER ? 'Teacher ID' : 'Student ID'} name = "student_id">
                        {(userData.role === ROLES.MANAGER) ?
                            <Input defaultValue = {data.student_id} />
                        :
                            <Input disabled defaultValue = {data.student_id} />
                        }
                    </Form.Item>
                    <Form.Item label="Ngày sinh" name = "date_of_birth">
                        <DatePicker placeholder="Chọn ngày" defaultValue={dayjs(formatDate(data.date_of_birth), dateFormat)} format={dateFormat} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="Email" name = "email">
                        <Input defaultValue = {data.email} />
                    </Form.Item>
                    <Form.Item label="Số điện thoại cá nhân" name = "phone_number">
                        <Input defaultValue = {data.phone_number} />
                    </Form.Item>
                    {   (data.role === ROLES.STUDENT) &&
                        <Form.Item label="Số điện thoại phụ huynh" name = "parent_number">
                        <Input defaultValue = {data.parent_number} disabled={userData.role === ROLES.STUDENT} />
                        </Form.Item>
                    }
                    <Form.Item label="Địa chỉ" name = "location">
                        <Input defaultValue = {data.location} />
                    </Form.Item>
                </div>

                <div className="profile-form-divider" />

                <div className="profile-pass">
                    <div className="profile-pass-head">
                        <div className="profile-pass-heading">
                            <LockOutlined className="profile-pass-ic" />
                            <div>
                                <div className="profile-pass-title">Mật khẩu</div>
                                <div className="profile-pass-desc">Đổi mật khẩu đăng nhập của bạn.</div>
                            </div>
                        </div>
                        <Button size="small" onClick={openPwModal}>Đổi mật khẩu</Button>
                    </div>
                </div>

                <Form.Item className="profile-form-actions">
                    <Button type="primary" htmlType="submit" onClick = {handleSubmit} loading={submitButtonLoading}>
                        Thay đổi
                    </Button>

                    <Button onClick = {cancelEdit}>
                        Hoàn tác
                    </Button>
                </Form.Item>
            </Form>

            <Modal
                title="Đổi mật khẩu"
                visible={pwOpen}
                onCancel={closePwModal}
                onOk={submitPassword}
                confirmLoading={pwLoading}
                okText="Đổi mật khẩu"
                cancelText="Hủy"
                maskClosable={false}
                destroyOnClose
                width={420}
            >
                <Form form={pwForm} layout="vertical" onFinish={submitPassword}>
                    <Form.Item label="Mật khẩu hiện tại" name="old_password"
                        rules={[{ required: true, message: 'Nhập mật khẩu hiện tại' }]}>
                        <Input.Password autoComplete="current-password" placeholder="Mật khẩu đang dùng" />
                    </Form.Item>
                    <Form.Item label="Mật khẩu mới" name="new_password" style={{ marginBottom: 8 }}
                        rules={[{ required: true, message: 'Nhập mật khẩu mới' }, { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự' }]}>
                        <Input.Password autoComplete="new-password" placeholder="Mật khẩu mới"
                            onChange={e => setNewPwd(e.target.value)} />
                    </Form.Item>
                    <PasswordStrength value={newPwd} />
                    <Form.Item label="Xác nhận mật khẩu mới" name="new_password_confirm" dependencies={['new_password']}
                        rules={[
                            { required: true, message: 'Nhập lại mật khẩu mới' },
                            ({ getFieldValue }) => ({
                                validator(_, v) {
                                    return !v || getFieldValue('new_password') === v
                                        ? Promise.resolve()
                                        : Promise.reject(new Error('Mật khẩu nhập lại không khớp'));
                                },
                            }),
                        ]}>
                        <Input.Password autoComplete="new-password" placeholder="Nhập lại mật khẩu mới" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
        :<></>
    );
}